module.exports = __webpack_public_path__ + "img/Speaker=Piro Dhimitri.db40af06.png";